// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__eYVyb","normalXl":"styles_normalXl__epma9","normalLg":"styles_normalLg__oyPhU","normalMd":"styles_normalMd__-oKKK","normalSm":"styles_normalSm__ZsyTk"};